<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Future Capital</span>
        <h3 class="page-title">Investment</h3>
      </d-col>
    </d-row>

    <d-row>
      <!-- Sidebar Widgets -->

      <d-col lg="12" md="12" class="row">
        <!-- 999 -->
        <d-card class="card-small mb-3 col-md-4 rp">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Investment Amount ₹ 999.00/-</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2">
                  <strong class="mr-1">No wallet</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Guaranteed profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Growth in daily basis</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Withdrawal your profit daily instantly</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Maximum double the amount in 3 month</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Minimum 10% to Maximum 25% daily profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3">
                <div
                  class="razorpay-embed-btn"
                  data-url="https://pages.razorpay.com/pl_F2zUr54xGXrFEb/view"
                  data-text="Invest Now"
                  data-color="#528FF0"
                  data-size="medium"
                ></div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>

        <!-- 4,999 -->
        <d-card class="card-small mb-3 col-md-4 rp">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Investment Amount ₹ 4,999.00/-</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2">
                  <strong class="mr-1">No wallet</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Guaranteed profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Growth in daily basis</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Withdrawal your profit daily instantly</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Maximum double the amount in 3 month</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Minimum 10% to Maximum 25% daily profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3">
                <div
                  class="razorpay-embed-btn"
                  data-url="https://pages.razorpay.com/pl_F4Zh0S8ypO3QzB/view"
                  data-text="Invest Now"
                  data-color="#528FF0"
                  data-size="medium"
                ></div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>

        <!-- 9,999 -->
        <d-card class="card-small mb-3 col-md-4 rp">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Investment Amount ₹ 9,999.00/-</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2">
                  <strong class="mr-1">No wallet</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Guaranteed profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Growth in daily basis</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Withdrawal your profit daily instantly</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Maximum double the amount in 3 month</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Minimum 10% to Maximum 25% daily profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3">
                <div
                  class="razorpay-embed-btn"
                  data-url="https://pages.razorpay.com/pl_F4a5QFURBxMGkT/view"
                  data-text="Invest Now"
                  data-color="#528FF0"
                  data-size="medium"
                ></div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>
        <!-- 2,999 -->
        <!-- <d-card class="card-small mb-3  col-md-4 rp">
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Investment Amount ₹ 2,999.00/-</h6>
                </d-card-header>

                <d-card-body class="p-0">
                    <d-list-group flush>
                        <d-list-group-item class="p-3">
                            <span class="d-flex mb-2"><strong class="mr-1">No wallet</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Guaranteed profit</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Growth in daily basis</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Withdrawal your profit daily instantly</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Maximum double the amount in 3 month</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Minimum 10% to Maximum 25% daily profit </strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                        </d-list-group-item>
                        <d-list-group-item class="d-flex px-3">
                            <div class="razorpay-embed-btn" data-url="https://pages.razorpay.com/pl_F4ZP8SpezW90KQ/view" data-text="Invest Now" data-color="#528FF0" data-size="medium"></div>
                        </d-list-group-item>
                    </d-list-group>
                </d-card-body>
        </d-card>-->
      </d-col>

      <d-col lg="12" md="12" class="row">
        <!-- 3,999 -->
        <!-- <d-card class="card-small mb-3  col-md-4 rp">
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Investment Amount ₹ 3,999.00/-</h6>
                </d-card-header>

                <d-card-body class="p-0">
                    <d-list-group flush>
                        <d-list-group-item class="p-3">
                            <span class="d-flex mb-2"><strong class="mr-1">No wallet</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Guaranteed profit</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Growth in daily basis</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Withdrawal your profit daily instantly</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Maximum double the amount in 3 month</strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                            <span class="d-flex mb-2"><strong class="mr-1">Minimum 10% to Maximum 25% daily profit </strong><i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i></span>
                        </d-list-group-item>
                        <d-list-group-item class="d-flex px-3">
                            <div class="razorpay-embed-btn" data-url="https://pages.razorpay.com/pl_F4ZcICIPz80SyX/view" data-text="Invest Now" data-color="#528FF0" data-size="medium"></div>
                        </d-list-group-item>
                    </d-list-group>
                </d-card-body>
        </d-card>-->

        <!-- 24,999 -->
        <d-card class="card-small mb-3 col-md-4 rp">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Investment Amount ₹ 24,999.00/-</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2">
                  <strong class="mr-1">No wallet</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Guaranteed profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Growth in daily basis</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Withdrawal your profit daily instantly</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Maximum double the amount in 3 month</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Minimum 10% to Maximum 25% daily profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3">
                <div
                  class="razorpay-embed-btn"
                  data-url="https://pages.razorpay.com/pl_F4a7X80ydTt1x1/view"
                  data-text="Invest Now"
                  data-color="#528FF0"
                  data-size="medium"
                ></div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>

        <!-- 49,999 -->
        <d-card class="card-small mb-3 col-md-4 rp">
          <d-card-header class="border-bottom">
            <h6 class="m-0">Investment Amount ₹ 49,999.00/-</h6>
          </d-card-header>

          <d-card-body class="p-0">
            <d-list-group flush>
              <d-list-group-item class="p-3">
                <span class="d-flex mb-2">
                  <strong class="mr-1">No wallet</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Guaranteed profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Growth in daily basis</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Withdrawal your profit daily instantly</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Maximum double the amount in 3 month</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
                <span class="d-flex mb-2">
                  <strong class="mr-1">Minimum 10% to Maximum 25% daily profit</strong>
                  <i style="font-size:25px;" class="material-icons mr-1 ml-auto">done</i>
                </span>
              </d-list-group-item>
              <d-list-group-item class="d-flex px-3">
                <div
                  class="razorpay-embed-btn"
                  data-url="https://pages.razorpay.com/pl_F4aBnSRIii36uw/view"
                  data-text="Invest Now"
                  data-color="#528FF0"
                  data-size="medium"
                ></div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>
        </d-card>
      </d-col>

      <!-- <d-col lg="12" md="12" class="row">


      </d-col>-->
    </d-row>
  </d-container>
</template>

<script>
export default {
  data() {
    return {
      IsAgentPage: false
    };
  },
  methods: {
    doLogout() {
      console.log("role");
    }
  },
  mounted() {
    //999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    // 1999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    // 2999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    //3999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    //4999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    //9999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    //24999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    //49999
    (function() {
      var d = document;
      var x = !d.getElementById("razorpay-embed-btn-js");
      if (x) {
        var s = d.createElement("script");
        s.defer = !0;
        s.id = "razorpay-embed-btn-js";
        s.src = "https://cdn.razorpay.com/static/embed_btn/bundle.js";
        d.body.appendChild(s);
      } else {
        var rzp = window["__rzp__"];
        rzp && rzp.init && rzp.init();
      }
    })();

    this.doLogout();
    console.log("role");
  }
};
</script>
